export enum FlightType {
    Departure = 'departure',
    Return = 'return',
    Connecting = 'connecting',
}